// Version traduite complète de FAQPage.jsx
// À remplacer dans FAQPage.jsx

import styles from './FAQPage.module.css';
import { useTranslation } from '../hooks/useTranslation';

function FAQPage() {
  const { t } = useTranslation();
  
  return (
    <div className={styles.page}>
      <h1>{t('faq.title')}</h1>
      <p className={styles.lastUpdate}>{t('faq.lastUpdate')} {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

      <div className={styles.section}>
        <h2>{t('faq.pro.title')}</h2>
        
        <h3>{t('faq.pro.whatIs.title')}</h3>
        <p dangerouslySetInnerHTML={{ __html: t('faq.pro.whatIs.text') }} />

        <h3>{t('faq.pro.benefits.title')}</h3>
        <p>{t('faq.pro.benefits.text')}</p>
        <ul>
          {t('faq.pro.benefits.items').map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>

        <h3>{t('faq.pro.subscribe.title')}</h3>
        <p>{t('faq.pro.subscribe.text')}</p>

        <h3>{t('faq.pro.cancel.title')}</h3>
        <p>
          {t('faq.pro.cancel.text')}{' '}
          <a href="mailto:cheriecoiffer@gmail.com">cheriecoiffer@gmail.com</a> {t('faq.pro.cancel.text2')}
        </p>
        <p>
          <strong>{t('faq.pro.cancel.important')}</strong> {t('faq.pro.cancel.importantText')}
        </p>

        <h3>{t('faq.pro.paymentFailed.title')}</h3>
        <p>{t('faq.pro.paymentFailed.text')}</p>

        <h3>{t('faq.pro.refund.title')}</h3>
        <p>{t('faq.pro.refund.text')}</p>
      </div>

      <div className={styles.section}>
        <h2>{t('faq.profile.title')}</h2>

        <h3>{t('faq.profile.create.title')}</h3>
        <p>{t('faq.profile.create.text')}</p>

        <h3>{t('faq.profile.edit.title')}</h3>
        <p>{t('faq.profile.edit.text')}</p>

        <h3>{t('faq.profile.delete.title')}</h3>
        <p>
          {t('faq.profile.delete.text')}{' '}
          <a href="mailto:cheriecoiffer@gmail.com">cheriecoiffer@gmail.com</a>.{' '}
          {t('faq.profile.delete.text2')}
        </p>
      </div>

      <div className={styles.section}>
        <h2>{t('faq.search.title')}</h2>

        <h3>{t('faq.search.howTo.title')}</h3>
        <p>{t('faq.search.howTo.text')}</p>

        <h3>{t('faq.search.city.title')}</h3>
        <p>{t('faq.search.city.text')}</p>
      </div>

      <div className={styles.section}>
        <h2>{t('faq.account.title')}</h2>

        <h3>{t('faq.account.create.title')}</h3>
        <p>{t('faq.account.create.text')}</p>

        <h3>{t('faq.account.forgotPassword.title')}</h3>
        <p>{t('faq.account.forgotPassword.text')}</p>

        <h3>{t('faq.account.delete.title')}</h3>
        <p>{t('faq.account.delete.text')}</p>
      </div>

      <div className={styles.section}>
        <h2>{t('faq.reviews.title')}</h2>

        <h3>{t('faq.reviews.howTo.title')}</h3>
        <p>{t('faq.reviews.howTo.text')}</p>

        <h3>{t('faq.reviews.edit.title')}</h3>
        <p>{t('faq.reviews.edit.text')}</p>
      </div>

      <div className={styles.section}>
        <h2>{t('faq.support.title')}</h2>

        <h3>{t('faq.support.contact.title')}</h3>
        <p>
          {t('faq.support.contact.text')}{' '}
          <a href="mailto:cheriecoiffer@gmail.com">cheriecoiffer@gmail.com</a>.
        </p>

        <h3>{t('faq.support.response.title')}</h3>
        <p>{t('faq.support.response.text')}</p>
      </div>
    </div>
  );
}

export default FAQPage;
